export const TIN_MATCH_RESET = 'TIN_MATCH_RESET';

export function tinMatchReset() {
  return {
    type: TIN_MATCH_RESET,
  };
}
